import { BaseControlBehaviour } from './BaseControlBehaviour';

declare class AwesomeScrollbar {
    constructor(containerSelector: any, addClass: string);
}

/**
 * Scrollbar - устанавливает Scrollbar
 */
export class ScrollbarBehaviour extends BaseControlBehaviour {
    constructor() {
        super('scrollbar');
    }

    protected installBehaviour(element: any): void {
        const globalAppSettings : any = (<any>window).globalAppSettings;

        if (globalAppSettings.isMobileDevice || globalAppSettings.site === 'unicom') {
            return;
        }

        new AwesomeScrollbar($(element), this.getBehaviorValue(element));
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ScrollbarBehaviour = ScrollbarBehaviour;